import { useTranslation } from 'react-i18next';
import { type ChartData } from './chartConfigUtils';
import StandardChart from './StandardChart';

interface MetalsIn24kData {
    readonly date: string;
    readonly grams: number;
}

interface MetalsIn24kChartProps {
    readonly data: readonly MetalsIn24kData[];
    readonly loading?: boolean;
    readonly referenceValue?: number;
}
function MetalsIn24kChart({
    data,
    loading = false,
    referenceValue,
}: MetalsIn24kChartProps): JSX.Element {
    const { t } = useTranslation();
    const chartData: ChartData[] = data.map(d => ({ date: d.date, value: d.grams ?? 0 }));
    return (
        <StandardChart
            data={chartData}
            loading={loading}
            referenceValue={referenceValue}
            config={{
                chartType: 'line',
                yAxisTitleKey: 'statistics.charts.metalsIn24kGrams',
                yAxisTitleFallback: 'Metals 24k (Grams)',
                yAxisColor: '#fa8c16',
                seriesNameKey: 'statistics.charts.metalsIn24k',
                seriesNameFallback: 'Metals in 24k',
                seriesColor: '#fa8c16',
                valueSuffix: t('statistics.grams', ' g') ?? ' g',
            }}
        />
    );
}

export default MetalsIn24kChart;
